export default {
  merkleDistributor: {
    321: '0x15208918b552D0E3A0502d1f454084F84432EB54',
    322: '0x38A0fF5405914a71C635616abf1B16CD52BECB0b',
  },
  secondMerkleDistributor: {
    321: '0x4f28d28df7da07b7631ea2b4f1993ac35573ab70',
    322: '0xf05e899E29278AaAb71A89da9b1D67A6412F2EaB',
  },
  masterChef: {
    321: '0x25C6d6A65C3ae5d41599Ba2211629B24604Fea4F',
    322: '0x84F10c60Aa2d69aA38Ae307D3bd57e2825BD5617',
  },
  masterChefV2: {
    321: '0xfdfcE767aDD9dCF032Cbd0DE35F0E57b04495324',
    322: '0xc7CBbb318318242fCC314ec723269d9E41ff6B4D',
  },
  mulltiCall: {
    321: '0xa64D6AFb48225BDA3259246cfb418c0b91de6D7a',
    322: '0x6367360366E4c898488091ac315834B779d8f561',
  },
  vault: {
    321: '0xF0D7C82E9f9bE85b2d1F8bedE40Afe1c1Fa7560c',
    322: '0x516dbE24c123C35930ef217553C177f81be0E64B',
  },
  vaultV2: {
    321: '0x3db85383aB912C9D9C003Bd2ec09107E0f37B8A0',
    322: '0x2010C439DA6fC2557eC582B8F4807715fF0ecf23',
  },
  swapMining: {
    321: '0x79Aa527F8D54016a75F5799da4eE198bb522413D',
    322: '0x4af2211877FbAb15289291ACf26075583AF695EC',
  },
  referral: {
    321: [
      '0x91E609094Aeb6Cb4cEDc6d3175694fd90d7e2690',
      '0xD3BA7e2F0589aa0c61c51ceC872202b6066129fc',
      '0x5D36A4DB638D7B4b6C2A8df616c181B7a9E7ECB0',
      '0xA76Ee9e227d0De5277EbBf2f67375c648844Ce42',
      '0xB4eBEA9AE9d3fFFA344926e7Dc388E35F2Cd44E3',
      '0xbe9b516987dDb3CFb54508B1dA119b17552be7E8',
      '0x9Dd2Ae950Ade895517D282E8C0Ef111607Db5B85',
    ],
    322: [
      '0x3783949E8D1861AcAcc4AdA9A4604e6E962Fe48d',
      '0x9e5af01E0f228d309a078BE70392EBF8b8a9608d',
      '0x182252dBA6E64A163914Fb96ABBDE5246CCE3a61',
      '0x7d7B832685C566d7234fea21609F635ab3802D87',
      '0x5BFF2b172177b6E83361510175C8884600dc78B4',
      '0x34E6fcd7949680CeF8b4d71A98ddB55F304B7db8',
      '0x2dA9b6f431A050a73f01ceFC900e834606EC0Bf3',
    ],
  },
  profile: {
    321: '0xb4c9817c173F20c342b05E91300eBfFe4E680E42',
    322: '0xeD07dFAA1B252b92F2A1bd29D3dD5C4Ee4B4eC52',
  },
  mojitoCattleFactory: {
    321: '0x5a99B2eB91Bea312201e1a9292ea45553F7E26Fe',
    322: '0x3AEF703Ff188EF6f574687DA22EbB3de99D5ad32',
  },
  pointCenterIfo: {
    321: '',
    322: '',
  },
  mojitoCattle: {
    321: '0x483Db86352f87225a3A2181886A4E8970552825F',
    322: '0x33a2cd72c04A740310bDa2b0C545653AD74f38eb',
  },
  lemonNft: {
    321: '0x4Ca64bF392ee736f6007Ce93E022DeB471a9dFd1',
    322: '0x975dD57640eb66639fD3FdA9Ed7D73B155321eeb',
  },
  nftMarket: {
    321: '0x8AA946F3FB38297917Ca91DCAf816721C59D0655',
    322: '0xF1D711FE6bdF6DB5588e7A2F238C7bA45B548aD2',
    // 321: '0xF1D711FE6bdF6DB5588e7A2F238C7bA45B548aD2',
    // 322: '0xAFcaC01f389548fdf8FE444B46bddb90c379a1D9',
  },
  luckyDrawResult: {
    321: '0xfe445ad4b9F6cED1BBce57222487aBa67a7CEfE3',
    322: '0xa27D419FD9C18a512fF456861c1D1D24D63ca420',
  },
  rolling: {
    321: '0x495d95989915bC24b963E0211516b47AE7322e35',
    322: '0xBc79F1e64CeBC7a815cAB1575E2d7d23dd47eEA3',
  },
  lotteryV2: {
    321: '0x78d3e1c3DCd21A54f5e7aA9245a1061c4f24AEC6',
    322: '0xA5Df9aaED255b59EEfd7f5211881312CbF1b5293',
  },
  chainlinkOracle: {
    321: '0xA5Df9aaED255b59EEfd7f5211881312CbF1b5293',
    322: '0xA5Df9aaED255b59EEfd7f5211881312CbF1b5293',
  },
  predictions: {
    321: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    322: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
  },
  predictionsETH: {
    321: '0x0903cD9492dE30e276A1631558cA300291396E03',
    322: '0x5c79C2306971958c938D1B85A3EfA5d4dDC05A8e',
  },
  chainlinkOracleETH: {
    321: '0x72E10386eBE0E3175f62BF3Edfc9A64aC3c5918a',
    322: '0x22337a9a305E081c0C801dd7B7b8eCF4966660bB',
  },
  predictionsBTC: {
    321: '0xCff9452F45553b5fd58B5DB61fEaF9B37752E98F',
    322: '0x0bB305090d522C51Ec4EaD4923929189eab193c9',
  },
  chainlinkOracleBTC: {
    321: '0xFAce3f85602A8dc013217b61a97a9AFE7B2F276F',
    // mock
    322: '0xa5d9b8412f935915fF710EeCfb70A3cEF643d522',
    // 322: '0xBb3423a913a9a69aD7Dba09B62abdFDE4643BAe4',
  },
}
